import LanguageSelector from "../../common/languageSelector";
import LoginShowcase from "./loginShowcase";

/**
 * Shared login/signup frame: the form on the left half with the language
 * selector in its top-right corner, and the LinkedScope MCP showcase on the right.
 */
function AuthSplitLayout({ currentLanguage, languageOptions, changeLanguage, children }) {
  return (
    <div className="login-component login-split">
      <div className="login-split-main">
        <LanguageSelector
          className="login-split-language"
          currentLanguage={currentLanguage}
          languageOptions={languageOptions}
          changeLanguage={changeLanguage}
        />
        {children}
      </div>

      <LoginShowcase />
    </div>
  );
}

export default AuthSplitLayout;
